import { useRouter } from '@boss/hooks';
import { ContentPageFields, Nullable } from '@boss/types/corporate-jobs';
import { Presence } from '@boss/ui';

import ComponentMapper from '../../mappers/ComponentMapper';

type Props = {
  cmsData?: Nullable<ContentPageFields>;
};

const NotFoundPage = ({ cmsData }: Props) => {
  const { locale } = useRouter();

  return (
    <Presence className="flex flex-col" id="404-page-presence" visible>
      {cmsData?.content?.map(entry => (
        <ComponentMapper entry={entry} key={entry.id} locale={locale} />
      ))}
    </Presence>
  );
};

export default NotFoundPage;
